export const REACT_API_URL= 'https://api.ezivote.com/api/v1/user';